import JsonApiObject from '@/_models/JsonApi'
import LanguageModel from '@/views/Language/models/language'

export default class LanguageStatisticsModel extends JsonApiObject {
    public constructor(data: any, included?) {
        super(data, included)
    }

    numStringsTotal
    numStringsUntranslated
    numStringsUnverified
    numStringsFinal

    get language(): LanguageModel {
        return this._relationships['language'] ? this._relationships['language'] : null
    }
}
